var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-center mt-5"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-icon',{attrs:{"font-scale":_vm.size,"icon":"arrow-clockwise","animation":"spin-pulse"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }